<template>
  <div>
    <div class="group-con">
      <div class="header acea-row row-between-wrapper">
        <div class="pictrue">
          <img :src="storeCombination.image" />
          </div>
        <div class="text">
          <div class="line1">{{storeCombination.title}}</div>
          <div class="money">
            ￥<span class="num">{{storeCombination.price}}</span
            ><span class="team cart-color">{{storeCombination.people}}人拼</span>
          </div>
        </div>
        <!--拼团失败  -->
        <div 
          v-if="isOk == 0 && !count && pinkBool == -1"
          class="iconfont icon-pintuanshibai"
          ></div>
        <!-- 拼团成功时把icon-pintuanshibai换成 icon-pintuanchenggong font-color -->
        <div 
          class="iconfont icon-pintuanchenggong font-color"
          v-if="isOk"
          ></div>
      </div>
      <div class="wrapper">
        <!-- 拼团失败或者成功不显示倒计时 -->
        <div class="title acea-row row-center-wrapper" v-if="!isOk">
          <div class="line"></div>
          <div class="name acea-row row-center-wrapper">
            剩余
            <div class="time font-color acea-row row-center-wrapper">
              <span>{{countDownHour || "00"}}</span>： 
              <span>{{countDownMinute || "00"}}</span>：
              <span>{{countDownSecond || "00"}}</span>
            </div>
            结束
          </div>
          <div class="line"></div>
        </div>
        <!-- 恭喜您拼团成功 -->
        <!-- 还差2人，拼团失败  去掉：font-color -->
        <div class="tips font-color" v-if="isOk">恭喜您拼团成功</div>
        <div class="tips" v-if="isOk == 0 && !count && pinkBool == -1">还差{{count}}人,拼团失败</div>
        <div class="tips font-color" v-if="!isOk && count">拼团中，还差{{count}}人拼团成功</div>
        <!-- 成功或失败时加：result -->
        <div 
          class="list acea-row row-middle"
          :class="[iShidden?'on':'',isOk?'result':'']"
          >
          <div class="pictrue"><img :src="pinkT.avatar"></div>
          <div class="pictrue" v-for="(item,index) in pinkAll" :key="index"><img :src="item.avatar" /></div>
          <div class="pictrue" v-for="(item,index) in count" :key="index"><img src="@assets/images/vacancy.png" ></div>
        </div>

        <!-- 分享团后进入页面-我要参团 -->
        
          <button
            @click="goPinkOrder"
            v-if="!isOk && !userBool"
            class="teamBnt bg-color"
            form-type="submit"
            hover-class="none"
          >
            我要参团
          </button>
        

        <!-- 本人开团或者拼团后按钮邀请好友参团 -->
        <!-- <button class='teamBnt bg-color' open-type='share' >邀请好友参团</button> -->
        <div class="teamBnt bg-color" @click="setShareInfoStatus" v-if="!isOk && userBool">邀请好友参团</div>
        
          <button
            style="display:block;margin:0 auto"
            v-if="!isOk && userBool && pinkT.uid==userInfo.uid"
            class="cancel" 
            form-type="submit" 
            hover-class="none"
            @click="removePink">
            <span class="iconfont icon-guanbi3"></span>取消开团
          </button>
        

        <!-- 拼团成功和失败: -->
        <div 
          v-if="isOk && (pinkAll.length+count+1) > 5"
          class="lookAll acea-row row-center-wrapper" 
          @click="lookAll">
          {{iShidden?'收起':'查看全部'}}
          <span 
            :class="[iShidden?'icon-xiangshang':'icon-xiangxia']"
            class="iconfont"></span>
        </div>
        <!-- 再次开团 -->
        <div class="teamBnt bg-color" @click="againPink" v-if="isOk && !count">再次开团</div>
        <!-- 重新开团 -->
        <div class="teamBnt bg-color" @click="againPink" v-if="isOk && count">重新开团</div>
        <!-- 拼团成功: -->
        <div
          v-if="isOk && !count"
          class="lookOrder"
          hover-class="none"
          url="/pages/order_details/index?order_id="
          @click="toOrderDetail"
          >查看订单信息<span class="iconfont icon-xiangyou"></span
        ></div>
      </div>
      <div class="group-recommend">
        <div class="title acea-row row-between-wrapper">
          <div>大家都在拼</div>
          <div
            hover-class="none"
            url="/pages/activity/goods_combination/index"
            class="more"
            @click="toMorecombination"
            >更多拼团<span class="iconfont icon-jiantou"></span
          ></div>
        </div>
        <div class="list acea-row row-middle">
          <div
            v-for="(item,index) in storeCombinationHost" :key="index"
            hover-class="none"
            class="item"
            wx:key="index"
            url="/pages/activity/goods_combination_details/index?id="
            @click="goCombinationDetails(item.id)"
          >
            <div class="pictrue">
              <img :src="item.image" />
              <div class="team">{{item.people}}人团</div>
            </div>
            <div class="name line1">{{item.title}}</div>
            <div class="money font-color">￥{{item.price}}</div>
          </div>
        </div>
      </div>
    </div>
    <Product-window
      v-on:changeFun="changeFun"
      :attr="attr"
      :iSplus="iSplus"
    ></Product-window>
    <ShareInfo
      v-on:setShareInfoStatus="setShareInfoStatus"
      :shareInfoStatus="shareInfoStatus"
    ></ShareInfo>
  </div>
</template>
<script>
import { getCombinationPink , getCombinationRemove } from "@api/activity";
import ShareInfo from "@components/ShareInfo";
import ProductWindow from "@components/ProductWindow";
import {postCartAdd} from "@api/store";
import { isWeixin } from "@utils/index";
import { wechatEvevt } from "@libs/wechat";
import dialog from "@utils/dialog";
export default {
  name: "GoodsCombinationStatus",
  components:{
    ProductWindow,
    ShareInfo
  },
  data() {
    return {
      iSplus:true,
      parameter: {
      'navbar': '1',
      'return': '1',
      'title': '开团',
      'color': false,
    },
      pinkId: "",
      count: 0, //还差多少人拼团完成
      isOk: 0, //是否拼团完成
      pinkAll: [], //当前拼团列表
      pinkBool: 0,  //拼团状态
      current_pink_order: "", //当前订单号
      pinkBool: 0,
      pinkT: {}, //团长信息
      storeCombination: {}, //当前拼团产品详情
      storeCombinationHost: [],
      userBool: 0, //是否为本人开团
      userInfo: {},
      productAttr: [],
      storeInfo: {},
      productValue: [],
      productSelect: [],

      countDownHour:'00',
      countDownMinute:'00',
      countDownSecond:'00',

      attr: {
        cartAttr: false,
        productAttr: [],
        productSelect: {}
      },
      attrValue:"",
      isOpen: false, //是否打开属性组件

      is_join:true,
    };
  },
  created() {
    //扫码携带处理（未处理）
    if (this.$route.query.scene) {
    }
    if (!this.$route.query.id) return this.$dialog.error({ mes: "缺少参数" });
    this.pinkId = this.$route.query.id;
  },
  mounted() {
    this.getPink();
  },
  methods: {
    /**
     * 获取拼团
     */
    getPink() {
      var that = this,
        id = that.pinkId;
      getCombinationPink(id).then(function (res) {
        var title = "开团";
        that.count = parseInt(res.data.count);
        that.isOk = res.data.is_ok;
        that.pinkBool  = res.data.pinkBool;
        that.pinkAll = res.data.pinkAll;
        that.current_pink_order = res.data.current_pink_order;
        that.pinkBool = res.data.pinkBool;
        that.pinkT = res.data.pinkT;
        that.storeCombination = res.data.store_combination;
        that.storeCombinationHost = res.data.store_combination_host;
        that.userBool = res.data.userBool;
        that.userInfo = res.data.userInfo;
        that.productAttr = res.data.store_combination.productAttr;
        that.storeInfo = res.data.store_combination;
        that.productValue = res.data.store_combination.productValue;
        that.setProductSelect();
        that.DefaultSelect();
        if (that.isOk && !that.count) {
          title = "拼团成功，等待商家发货"; //拼团完成
        } else if (that.isOk && that.count) {
          title = "拼团失败"; //拼团失败
        } else if (that.userBool && !that.isOk) {
          title = that.pinkT.uid == that.userInfo.uid ? "开团成功" : "拼团成功"; //本人开团成功
          that.time(that.pinkT.stop_time, that);
        } else if (!that.userBool && !that.isOk) {
          title = "参团"; //本人参团
          that.time(that.pinkT.stop_time, that);
        }
        that.parameter.title = title
        that.setOpenShare();
      }).catch(res =>{
        if(res.data.status == 400){
          this.$dialog.error(res.data.msg);
          this.$router.go(-1);
        }
      })
    },
    setProductSelect() {
      var that = this;
      if (that.productSelect.length == 0) {
        that.$set(that.productSelect,"image",that.storeInfo.image);
        that.$set(that.productSelect,"store_name",that.storeInfo.title);
        that.$set(that.productSelect,"price",that.storeInfo.price);
        that.$set(that.productSelect,"quota",that.storeInfo.stock);
        that.$set(that.productSelect,"unique","");
        that.$set(that.productSelect,"cart_num",1);
        // that.productSelect.image = that.storeInfo.image;
        // that.productSelect.store_name = that.storeInfo.title;
        // that.productSelect.price = that.storeInfo.price;
        // that.productSelect.quota = that.storeInfo.stock;
        // that.productSelect.unique = "";
        // that.productSelect.cart_num = 1;
        
        that.$set(that.attr.productSelect,"image",that.storeInfo.image);
        that.$set(that.attr.productSelect,"store_name",that.storeInfo.title);
        that.$set(that.attr.productSelect,"price",that.storeInfo.price);
        that.$set(that.attr.productSelect,"quota",that.storeInfo.stock);
        that.$set(that.attr.productSelect,"unique","");
        that.$set(that.attr.productSelect,"cart_num",1);
        // that.attr.productSelect.image = that.storeInfo.image;
        // that.attr.productSelect.store_name = that.storeInfo.title;
        // that.attr.productSelect.price = that.storeInfo.price;
        // that.attr.productSelect.quota = that.storeInfo.stock;
        // that.attr.productSelect.unique = "";
        // that.attr.productSelect.cart_num = 1;
      }
    },
    /**
     * 默认选中属性
     *
     */
    DefaultSelect(){
      var productAttr = this.productAttr, 
      storeInfo = this.storeInfo, 
      productValue = this.productValue, 
      value = [];
    for (var key in productValue) {
      if (productValue[key].quota > 0 && productValue[key].product_stock > 0) {
        value = this.productAttr.length ? key.split(",") : [];
        break;
      }
    }
    for (var i = 0, len = productAttr.length; i < len; i++) {
      if (productAttr[i].attr_value[0]) productAttr[i].checked = value[i];
    }
    var productSelect = this.productValue[value.sort().join(',')];
    if (productSelect) {
      this.$set(this.attr.productSelect,"store_name",storeInfo.title)
      this.$set(this.attr.productSelect,"image",productSelect.image)
      this.$set(this.attr.productSelect,"price",productSelect.price)
      this.$set(this.attr.productSelect,"quota",productSelect.quota)
      this.$set(this.attr.productSelect,"stock",productSelect.stock)
      this.$set(this.attr.productSelect,"quota_show",productSelect.quota_show)
      this.$set(this.attr.productSelect,"product_stock",productSelect.product_stock)
      this.$set(this.attr.productSelect,"unique",productSelect.unique);
      this.$set(this.attr.productSelect,"cart_num",1);
      // this.attr.productSelect.store_name = storeInfo.title;
      // this.attr.productSelect.image = productSelect.image;
      // this.attr.productSelect.price = productSelect.price;
      // this.attr.productSelect.quota = productSelect.quota;
      // this.attr.productSelect.stock = productSelect.stock;
      // this.attr.productSelect.quota_show = productSelect.quota_show;
      // this.attr.productSelect.product_stock = productSelect.product_stock;
      // this.attr.productSelect.unique = productSelect.unique;
      // this.attr.productSelect.cart_num = 1;
      this.$set(this, "attrValue", value);
      this.$set(this, "attrTxt", "已选择");
    } else {
      this.$set(this.attr.productSelect,"store_name",storeInfo.title);
      this.$set(this.attr.productSelect,"image",storeInfo.image);
      this.$set(this.attr.productSelect,"price",storeInfo.price);
      this.$set(this.attr.productSelect,"quota",0);
      this.$set(this.attr.productSelect,"unique","");
      this.$set(this.attr.productSelect,"cart_num",this.productAttr.length ? 0 : 1);

      // this.attr.productSelect.store_name = storeInfo.title;
      // this.attr.productSelect.image = storeInfo.image;
      // this.attr.productSelect.price = storeInfo.price;
      // this.atte.productSelect.quota = 0;
      // this.attr.productSelect.unique = "";
      // this.attr.productSelect.cart_num = this.productAttr.length ? 0 : 1;
      this.$set(this, "attrValue", "");
      this.$set(this, "attrTxt", "请选择");
    }
    this.attr.productAttr = productAttr;
    return
    },
    changeFun: function (opt) {
      if (typeof opt !== "object") opt = {};
      let action = opt.action || "";
      let value = opt.value === undefined ? "" : opt.value;
      this[action] && this[action](value);
    },
    changeattr: function (msg) {
      this.attr.cartAttr = msg;
      this.isOpen = false;
    },
    ChangeCartNum: function(changeValue) {
      //changeValue:是否 加|减
      //获取当前变动属性
      let productSelect = this.productValue[this.attrValue];
      //如果没有属性,赋值给商品默认库存
      if (productSelect === undefined && !this.attr.productAttr.length);
        
        productSelect = this.attr.productSelect;
        
      //无属性值即库存为0；不存在加减；
      if (productSelect === undefined) return;
      
      let quota_show = productSelect.quota_show || 0;
      
      let num = this.attr.productSelect;
      
      if (changeValue) {
        num.cart_num++;
        if (num.cart_num > quota_show) {
          this.$set(this.attr.productSelect, "cart_num", quota_show ? quota_show : 1);
          this.$set(this, "cart_num", quota_show ? quota_show : 1);
        }
      } else {
        num.cart_num--;
        if (num.cart_num < 1) {
          this.$set(this.attr.productSelect, "cart_num", 1);
          this.$set(this, "cart_num", 1);
        }
      }
    },
    time(timeStamp, that) {
      var interval = null,
        totalSecond = timeStamp - Date.parse(new Date()) / 1000;
      interval = setInterval(
        function () {
          // 秒数
          var second = totalSecond;

          // 小时位
          var hr = Math.floor(second / 3600);
          var hrStr = hr.toString();
          if (hrStr.length == 1) hrStr = "0" + hrStr;

          // 分钟位
          var min = Math.floor((second - hr * 3600) / 60);
          var minStr = min.toString();
          if (minStr.length == 1) minStr = "0" + minStr;

          // 秒位
          var sec = second - hr * 3600 - min * 60;
          var secStr = sec.toString();
          if (secStr.length == 1) secStr = "0" + secStr;
          that.countDownHour = hrStr;
          that.countDownMinute = minStr;
          that.countDownSecond = secStr;
          totalSecond--;
          if (totalSecond <= 0) {
            clearInterval(interval);
            that.is_join = false;
            this.$dialog.error("活动已结束")
            setTimeout(()=>{
              this.$router.go(-1);
            },800)
            
            that.countDownHour = "00"
            that.countDownMinute = "00"
            that.countDownSecond = "00"
          }
        }.bind(that),
        1000
      );
      that.interval = interval
    },
    getPinkPoster() {
    var that = this;
    that.$router.push({
      path:`/activity/poster_poster?type=2&id=${that.pinkId}`
    })
  },
  // 我要参团
  goPinkOrder(e){
    let that = this;
    if(!that.is_join) return;
    let productSelect = that.productValue[this.attrValue];
    if (that.attrValue) {
        //默认选中了属性，但是没有打开过属性弹窗还是自动打开让用户查看默认选中的属性
        that.attr.cartAttr = !that.isOpen ? true : false;
      } else {
        if (that.isOpen) that.attr.cartAttr = true;
        else that.attr.cartAttr = !that.attr.cartAttr;
      }
      //只有关闭属性弹窗时进行加入购物车
      if (that.attr.cartAttr === true && that.isOpen === false)
        return (that.isOpen = true);
      if (
        !this.attr.productSelect.cart_num ||
        parseInt(this.attr.productSelect.cart_num) <= 0
      )
        return that.$dialog.toast({ mes: "请输入购买数量" });
      //如果有属性,没有选择,提示用户选择
      if (
        that.attr.productAttr.length &&
        productSelect === undefined &&
        that.isOpen === true
      )
        return that.$dialog.toast({ mes: "产品库存不足，请选择其它" });
    // that.attr.cartAttr = true;
    
    // let data = {
    //   productId: that.storeCombination.product_id,
    //   cartNum: that.pinkT.total_num,
    //   uniqueId: '',
    //   combinationId: that.storeCombination.id,
    //   secKillId: 0
    // };
    // postCartAdd(data).then(function(res){
    //   that.$router.push({
    //     path:`/order/submit/${res.data.cartId}?pinkId=${that.pinkT.id}`,
    //   })
    // }).catch(err=>{
    //   return that.$dialog.toast({ mes: err.msg });
    // });
  },
  goPay(){
    let that = this;
    let data = {
      productId: that.storeCombination.product_id,
      cartNum: that.attr.productSelect.cart_num,
      uniqueId: '',
      combinationId: that.storeCombination.id,
      secKillId: 0
    };
    postCartAdd(data).then(function(res){
      that.$router.push({
        path:`/order/submit/${res.data.cartId}?pinkId=${that.pinkT.id}`,
      })
    }).catch(err=>{
      return that.$dialog.toast({ mes: err.msg });
    });
  },
  removePink(e){
    let that = this, data = {
      id: this.pinkId,
      cid: this.storeCombination.id,
    }
    dialog.confirm({
      mes:"确认取消拼团",
      opts(){
        getCombinationRemove(data).then(function(res){
          that.$dialog.success(res.msg);
          setTimeout(function(){
            that.$router.push({
            path:`/activity/goods_combination`
          })
        },800)
        }).catch(function (res) {
        return that.$dialog.error(res.msg);
        })
      }
    })
    
  },
  againPink:function(){
    this.$router.push({
      path:`/activity/goods_combination_details?id=${this.storeCombination.id}`
    })
  },
  setShareInfoStatus: function() {
    this.shareInfoStatus = !this.shareInfoStatus;
    this.posters = false;
    },
  toMorecombination(){
    this.$router.push({
      path:`/activity/goods_combination`
    })
  },
  goCombinationDetails(id){
    this.$router.push({
      path:`/activity/goods_combination_details?id=${id}`
    })
  },
  // 查看订单详情
  toOrderDetail(){
    this.$router.push({
      path:`/order/detail/${this.current_pink_order}`
    })
  },
  setOpenShare: function() {
      var data = this.storeCombination;
      var href = location.href;
      if (isWeixin()) { 
        var configAppMessage = {
            desc: data.info,
            title: `您的好友${this.userInfo.nickname}邀请您一起来拼${data.title}`,
            link: href,
            imgUrl: data.image
          };
          wechatEvevt(
            [
              "updateAppMessageShareData",
              "updateTimelineShareData",
              "onMenuShareAppMessage",
              "onMenuShareTimeline"
            ],
            configAppMessage
          )
            .then(res => {
              console.log(res);
            })
            .catch(res => {
              if (res.is_ready) {
                res.wx.updateAppMessageShareData(configAppMessage);
                res.wx.onMenuShareAppMessage(configAppMessage);
                res.wx.updateTimelineShareData(configAppMessage);
                res.wx.onMenuShareTimeline(configAppMessage);
              }
            });
      }
    },
  },
};
</script>
<style scoped>
.bg-color {
  background-color: #000000!important;
}
.cart-color {
  color: #9dccd0!important;
  border: 1px solid #9dccd0!important;
}
.group-con .header {
  width: 100%;
  height: 1.86rem;
  background-color: #fff;
  border-top: 1px solid #f5f5f5;
  padding: 0 0.3rem;
  box-sizing: border-box;
  position: relative;
}
.group-con .header .iconfont {
  font-size: 1rem;
  position: absolute;
  color: #ccc;
  right: .33rem;
  bottom: .2rem;
}
.group-con .header .pictrue {
  width: 1.4rem;
  height: 1.4rem;
}
.group-con .header .pictrue img {
  width: 100%;
  height: 100%;
  border-radius: 3px;
}
.group-con .header .text {
  width: 5.25rem;
  font-size: .3rem;
  color: #222;
}
.group-con .header .text .money {
  font-size: .24rem;
  font-weight: bold;
  margin-top: .19rem;
}
.group-con .header .text .money .num {
  font-size: .32rem;
}
.group-con .header .text .money .team {
  padding: .02rem .1rem;
  font-weight: normal;
  border-radius: 25px;
  box-sizing: border-box;
  font-size: .2rem;
  vertical-align: .04rem;
  margin-left: .15rem;
}
.group-con .wrapper {
  background-color: #fff;
  margin-top: .2rem;
  padding: .02rem 0 .35rem 0;
}
.group-con .wrapper .title {
  margin-top: .3rem;
}
.group-con .wrapper .title .line {
  width: 1.36rem;
  height: .01rem;
  background-color: #ddd;
}
.group-con .wrapper .title .name {
  margin: 0 .15rem;
  font-size: .28rem;
  color: #282828;
}
.group-con .wrapper .title .name .time {
  margin: 0 .14rem;
}
.group-con .wrapper .title .name .time span {
  width: .42rem;
  height: .42rem;
  background-color: #ffcfcb;
  text-align: center;
  line-height: .42rem;
  border-radius: 1.5px;
  display: block;
  font-size: .28rem;
  font-weight: bold;
}
.group-con .wrapper .tips {
  font-size: .3rem;
  font-weight: bold;
  text-align: center;
  margin-top: .3rem;
  color: #999;
}
.group-con .wrapper .list {
  padding: 0 .3rem;
  margin-top: .45rem;
}
.group-con .wrapper .list.result {
  max-height: 2.4rem;
  overflow: hidden;
}
.group-con .wrapper .list.result.on {
  max-height: 20rem;
}
.group-con .wrapper .list .pictrue {
  width: .94rem;
  height: .94rem;
  margin: 0 0 .29rem .35rem;
}
.group-con .wrapper .list .pictrue img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 1px solid #ff554c;
}
.group-con .wrapper .list .pictrue:nth-last-child(1) img {
  border: none;
}
.group-con .wrapper .lookAll {
  font-size: .24rem;
  color: #282828;
  padding-top: .1rem;
}
.group-con .wrapper .lookAll .iconfont {
  font-size: .25rem;
  margin: .02rem 0 0 .1rem;
}
.group-con .wrapper .teamBnt {
  display: block;
  font-size: .3rem;
  width: 6.2rem;
  height: .86rem;
  border-radius: 25px;
  text-align: center;
  line-height: .86rem;
  color: #fff;
  margin: .21rem auto 0 auto;
}
.group-con .wrapper .cancel,
.group-con .wrapper .lookOrder {
  text-align: center;
  font-size: .24rem;
  color: #282828;
  padding-top: .3rem;
}
.group-con .wrapper .cancel .iconfont {
  font-size: .35rem;
  color: #2c2c2c;
  vertical-align: -.04rem;
  margin-right: .09rem;
}
.group-con .wrapper .lookOrder .iconfont {
  font-size: .25rem;
  color: #2c2c2c;
  margin-left: .1rem;
}
.group-con .group-recommend {
  background-color: #fff;
  margin-top: .25rem;
}
.group-con .group-recommend .title {
  padding-right: .3rem;
  margin-left: .3rem;
  height: .85rem;
  border-bottom: 1px solid #eee;
  font-size: .28rem;
  color: #282828;
}
.group-con .group-recommend .title .more {
  color: #808080;
}
.group-con .group-recommend .title .more .iconfont {
  margin-left: .13rem;
  font-size: .28rem;
}
.group-con .group-recommend .list {
  margin-top: .3rem;
}
.group-con .group-recommend .list .item {
  width: 2.1rem;
  margin: 0 0 .25rem .3rem;
}
.group-con .group-recommend .list .item .pictrue {
  width: 100%;
  height: 2.1rem;
  position: relative;
}
.group-con .group-recommend .list .item .pictrue img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}
.group-con .group-recommend .list .item .pictrue .team {
  position: absolute;
  top: .28rem;
  left: -.05rem;
  min-width: 1rem;
  height: .36rem;
  line-height: .36rem;
  text-align: center;
  background-image: linear-gradient(to right, #fb5445 0%, #ff554c 100%);
  border-radius: 0 9px 9px 0;
  font-size: .2rem;
  color: #fff;
}
.group-con .group-recommend .list .item .name {
  font-size: .28rem;
  color: #333;
  margin-top: .18rem;
}
.group-con .group-recommend .list .item .money {
  font-weight: bold;
  font-size: .26rem;
  margin-top: .05rem;
}
</style>